//Margin component for Pie, Gauge, Rose and Donuts

import React from 'react';
import SliderWithInput from '../../SliderWithInput';

interface RadiusMarginsProps {
  radius?: number;
  gaugeRadius?: number;
  innerRadius?: number;
  outerRadius?: number;
  onChange: (option: string, value: number) => void;
  chartType: string;
  iconColor?: string;
}

const RadiusMargins: React.FC<RadiusMarginsProps> = ({
  radius,
  gaugeRadius,
  innerRadius,
  outerRadius,
  onChange,
  chartType,
  iconColor,
}) => {
  const displayRadius = chartType === 'gauge' ? gaugeRadius : radius;
  return (
    <>
      {(radius !== undefined || gaugeRadius !== undefined) && (
        <>
          <div
            className="optionDescription"
            style={{
              marginTop: '0',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Radius:
          </div>
          <SliderWithInput
            percent={true}
            sliderValue={displayRadius ?? 0}
            sliderMinMax={{ min: 10, max: 100, step: 1 }}
            changeValue={(value) =>
              onChange(chartType === 'gauge' ? 'gaugeRadius' : 'radius', value)
            }
          />
        </>
      )}
      {innerRadius !== undefined && outerRadius !== undefined && (
        <>
          <div
            className="optionDescription"
            style={{
              marginTop: '10px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Inner Radius:
          </div>
          <SliderWithInput
            percent={true}
            sliderValue={innerRadius}
            sliderMinMax={{ min: 0, max: 90, step: 1 }}
            changeValue={(value) => onChange('innerRadius', value)}
          />
          <div
            className="optionDescription"
            style={{
              marginTop: '5px',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Outer Radius:
          </div>
          <SliderWithInput
            percent={true}
            sliderValue={outerRadius}
            sliderMinMax={{ min: 10, max: 100, step: 1 }}
            changeValue={(value) => onChange('outerRadius', value)}
          />
        </>
      )}
    </>
  );
};

export default RadiusMargins;
